import router from './router'
import { getToken, getUser } from '@/utils/auth'
import getPageTitle from '@/utils/get-page-title'
// const whiteList = ['/login', '/:code', '/'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  // set page title
  document.title = getPageTitle(to.meta.title)
  // determine whether the user has logged in
  const hasToken = getToken()
  const hasUser = getUser()
  if (hasToken !== undefined && hasUser !== undefined) {
    if (to.path === '/login' || to.path === '/oauth') {
      // if is logged in, redirect to the home page\
      if (Object.keys(to.query).length > 0) {
        next(to.query.redirect)
      } else {
        next('/')
      }
    } else {
      next()
    }
  } else {
    /* has no token */
    if (to.path === '/logout') {
      next('/login')
    } else if (to.path === '/oauth' && to.query.code === undefined) {
      next('/login')
    } else if (to.path === '/member' || to.path === '/address' || to.path.indexOf('/address/edit') !== -1 || to.path === '/address/add' || to.path === '/coupon' || to.path === '/checkout') {
      next(`/login?redirect=${to.path}`)
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js